const cache = {};
const JOBS_LIST_CACHE_TTL_MS = 2 * 60 * 1000;

export function getCachedJobsList(queryKey) {
  if (!queryKey) return null;
  const entry = cache[queryKey];
  if (!entry) return null;
  const isFresh = Date.now() - entry.cachedAt <= JOBS_LIST_CACHE_TTL_MS;
  return isFresh ? entry.data : null;
}

export function primeJobsListCache(queryKey, data) {
  if (!queryKey || !data) return;
  cache[queryKey] = {
    data,
    cachedAt: Date.now(),
  };
}
